<template>
  <span :class="['q-badge', `q-badge--${resolvedCls}`]">{{ resolvedLabel }}</span>
</template>

<script>
const STATUS_CONFIG = {
  activo:    { label: "Activo",    cls: "success"  },
  inactivo:  { label: "Inactivo",  cls: "danger"   },
  pendiente: { label: "Pendiente", cls: "warning"  },
  borrado:   { label: "Borrado",   cls: "neutral"  },
  error:     { label: "Error",     cls: "danger"   },
  info:      { label: "Info",      cls: "info"     },
  bot:       { label: "Bot",       cls: "info"     },
  pagado:    { label: "Pagado",    cls: "success"  },
  devuelto:  { label: "Devuelto",  cls: "warning"  },
  cancelado: { label: "Cancelado", cls: "danger"   },
};

export default {
  name: "QBadge",
  props: {
    status: { type: String, default: "activo" },
    label:  { type: String, default: null },
  },
  computed: {
    resolvedCls() {
      const key = (this.status || "").toLowerCase();
      return STATUS_CONFIG[key]?.cls ?? "neutral";
    },
    resolvedLabel() {
      if (this.label) return this.label;
      const key = (this.status || "").toLowerCase();
      return STATUS_CONFIG[key]?.label ?? this.status;
    },
  },
};
</script>

<style scoped>
.q-badge {
  display: inline-block;
  font-family: var(--q-font-ui, 'Inter', sans-serif);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid;
  line-height: 1.4;
  white-space: nowrap;
}
.q-badge--success {
  background: var(--q-green-soft, #0c2a1a);
  border-color: var(--q-green, #2ee27f);
  color: var(--q-green, #2ee27f);
}
.q-badge--danger {
  background: var(--q-red-soft, #2c1216);
  border-color: var(--q-red, #ff5964);
  color: var(--q-red, #ff5964);
}
.q-badge--warning {
  background: var(--q-amber-soft, #241a09);
  border-color: var(--q-amber, #f5a623);
  color: var(--q-amber, #f5a623);
}
.q-badge--neutral {
  background: var(--q-hover, #111926);
  border-color: var(--q-border-md, #243040);
  color: var(--q-muted, #7c8ba1);
}
.q-badge--info {
  background: rgba(245, 166, 35, 0.08);
  border-color: var(--q-gold, #f5a623);
  color: var(--q-gold, #f5a623);
}
</style>
